/**
 * @generated SignedSource<<396d78a6248b5ab00a686dbbf486a439>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VoterPanelNameSectionFragment$data = {
  readonly address: string;
  readonly name: string | null;
  readonly " $fragmentType": "VoterPanelNameSectionFragment";
};
export type VoterPanelNameSectionFragment$key = {
  readonly " $data"?: VoterPanelNameSectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VoterPanelNameSectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VoterPanelNameSectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "ResolvedName",
  "abstractKey": null
};

(node as any).hash = "62cbebb199665fcaa07f300e4caa52f0";

export default node;
